<template>
  <div class="navbar">
    <el-menu mode="horizontal">
      <div class="header-flex">
        <div class="flex-left">
          <hamburger :toggle-click="toggleSideBar"
                     :is-active="sidebar.opened"
                     class="hamburger-container" />
          <breadcrumb class="breadcrumb-container" />
        </div>
        <div class="flex-right">
          <!--<span class="help-wrapper">-->
          <!--<el-dropdown class="avatar-container" @command="switchTheme" trigger="click">-->
          <!--<div class="avatar-wrapper">-->
          <!--<svg-icon iconClass="主题切换" class="user-theme"></svg-icon>-->
          <!--<span>主题</span>-->
          <!--<i class="el-icon-caret-bottom"/>-->
          <!--</div>-->
          <!--<el-dropdown-menu slot="dropdown" class="user-dropdown">-->
          <!--<el-dropdown-item command="default" :disabled="theme=='default'">-->
          <!--<span>默认主题</span>-->
          <!--</el-dropdown-item>-->
          <!--<el-dropdown-item command="dark" :disabled="theme=='dark'">-->
          <!--<span>暗黑主题</span>-->
          <!--</el-dropdown-item>-->
          <!--</el-dropdown-menu>-->
          <!--</el-dropdown>-->
          <!--</span>-->

          <span>
            <el-dropdown class="avatar-container"
                         trigger="click">
              <div class="avatar-wrapper">
                <svg-icon icon-class="头像"
                          class="user-avatar" />
                <!-- <span>{{ name }}</span> -->
                <span>{{ name || '用户名'}}</span>
                <i class="el-icon-caret-bottom" />
              </div>
              <el-dropdown-menu slot="dropdown"
                                class="user-dropdown">
                <router-link class="inlineBlock"
                             to="/">
                  <el-dropdown-item>
                    首页
                  </el-dropdown-item>
                </router-link>
                <el-dropdown-item>
                  <span style="display:block;"
                        @click="modifyPass">修改密码</span>
                </el-dropdown-item>
                <el-dropdown-item divided>
                  <span style="display:block;"
                        @click="logout">登出</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </span>
        </div>
      </div>
    </el-menu>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Breadcrumb from '@/components/breadcrumb.vue';
import Hamburger from '@/components/hamburger.vue';

export default {
  components: {
    Breadcrumb,
    Hamburger,
  },
  computed: {
    ...mapGetters(['sidebar', 'device', 'avatar', 'theme', 'name']),
  },
  methods: {
    ...mapActions(['ChangeTheme']),
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar');
    },
    modifyPass() {
      this.$router.push({ path: '/modifyPassword', query: { redirect: this.$router.history.current.fullPath } });
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        window.location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
    switchTheme(theme) {
      if (this.theme !== theme) {
        // 在main.js中loadCss后再实例化vue实例
        this.ChangeTheme(theme);
        window.location.reload();
      }
    },
  },
};
</script>
<style lang="less">
.navbar {
  border-left: 1px solid #18191A;
  background: #2C2C2E;
  /deep/.el-menu {
    background: #2C2C2E;
    border-bottom-color: #2C2C2E!important;
    .el-breadcrumb__inner a {
      color: #C0C4CC !important;
    }
  }
}
.hamburger-container {
  & > svg {
    vertical-align: middle;
  }
}
</style>
